<template>
    <div class="settings">
        <p>Settings</p>
    </div>
</template>

<script type="text/javascript">
export default {
    data () {
        return {
            message: "Hello World!!"
        }
    }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Settings.vue